<template>
    <div>
        <Header v-bind:title="'检验明细'" v-bind:back="true"></Header>
        <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="list.length > 0 ? '已全部加载' : '无检验明细'"
                @load="getList()">
            <el-table
                    :data="list"
                    stripe
                    :row-class-name="yCRowClass"
                    size="small">
                <el-table-column prop="xh" label="序号" width="50"></el-table-column>
                <el-table-column prop="xmmc" label="项目名称" width="160"></el-table-column>
                <el-table-column prop="jyjg" label="检验值" width="90"></el-table-column>
                <el-table-column prop="dw" label="单位" width="80"></el-table-column>
                <el-table-column prop="ckz" label="参考值" width="100">
                    <template slot-scope="scope">
                        {{scope.row.ckz ? scope.row.ckz : '-'}}
                    </template>
                </el-table-column>
                <el-table-column prop="sfyc" label="是否异常" width="90">
                    <template slot-scope="scope">
                        {{scope.row.sfyc ? scope.row.sfyc : '正常'}}
                    </template>
                </el-table-column>
            </el-table>
            <!--<van-cell-group v-for="(item,index) in list" :key="index">-->
                <!--<van-cell center :title="item.xmmc">-->
                    <!--<template slot="label">-->
                        <!--<span>单位:12</span><br>-->
                        <!--<span>是否异常:是</span><br>-->
                    <!--</template>-->
                <!--</van-cell>-->
            <!--</van-cell-group>-->
        </van-list>
    </div>
</template>
<script type="text/ecmascript-6">
    import Header from './components/Header.vue'
    import {findJyjlMx} from '@/api/biApi.js'
    let Base64 = require('js-base64').Base64;

    export default{
        name:'',
        components:{Header},
        data(){
            return {
                row:{},
                list:[],
                loading:false,
                finished:false,
                pageSize:200,
            }
        },
        mounted(){
            this.row = this.$route.params.row ? JSON.parse(Base64.decode(this.$route.params.row)) : {}
        },
        methods:{
            getList(){
                findJyjlMx({
                    "jybgid":this.row.jybgid,
                    "size":this.pageSize,
                    "page":1
                }).then(res=>{
                    this.list = res.list
                    this.loading = false;
                    this.finished = true;
                }).catch(err=>{
                    this.$toast('获取失败');
                    this.loading = false;
                    this.finished = true;
                })
            },
            yCRowClass({row,rowIndex}){
                if(row.sfyc && row.sfyc == '偏高'){
                    return 'yc_high';
                }
                if(row.sfyc && row.sfyc == '偏低'){
                    return 'yc_low';
                }
            },
        }
    }
</script>
<style>
    .yc_high {
        color:#F56C6C;
        background: #FCE2E2;
    }
    .yc_low{
        color:#409EFF;
        background: #C7E2FE;
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile/jyjl-jyjl-xx.vue